import { Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ITablePagination, NotificationItem } from 'src/app/models';
import { NotificationDataService } from 'src/app/services';
import { handleError } from 'src/app/state/akita-error-helper';
import { ErrorState } from 'src/app/state/error-state';
import { IPage } from 'src/app/state/paged-collection';

@Injectable({
  providedIn: 'root',
})
export class ConstructionLogService {
  private readonly state = new ErrorState();

  public readonly error$ = this.state.error$;

  public constructor(private readonly notificationDataService: NotificationDataService) {}

  public loadConstructionLog(
    pagination: ITablePagination,
    equipmentNumber: string,
    entryTypes: string[],
    entryCodes?: string[]
  ): Observable<IPage<NotificationItem>> {
    // Starting a load clears the previous error, which CustomEntityStore.setLoading(true)
    // used to do. Without it a transient failure sticks: the template renders the error
    // instead of the table, so a later success would never be seen.
    this.state.setError(undefined);

    return this.notificationDataService
      .getConstructionLogPage(pagination, equipmentNumber, entryTypes, entryCodes)
      .pipe(
        map(({ data, total }): IPage<NotificationItem> => ({
          currentPage: pagination.page,
          data,
          lastPage: Math.ceil(total / pagination.perPage),
          perPage: pagination.perPage,
          total,
        })),
        catchError((error) => {
          handleError(this.state, error);

          // EMPTY, not NEVER: PagedCollection's finalize() has to run to clear the
          // spinner. Akita got this implicitly, because its setError also called
          // set([]), which cleared loading.
          return EMPTY;
        })
      );
  }

  public clearError() {
    this.state.setError(undefined);
  }
}
